document.addEventListener("DOMContentLoaded", function () {
  const FREEBIE_VARIANT_ID = 48122802372863; // 🔁 replace with your variant ID

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const freebieItem = cart.items.find(
        item => item.variant_id === FREEBIE_VARIANT_ID
      );

      // 🟢 CASE 1: Cart has items, but no freebie → add it
      if (cart.item_count > 0 && !freebieItem) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: FREEBIE_VARIANT_ID,
            quantity: 1
          })
        }).then(() => location.reload());
      }
    });
});
